import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ButtonComponent, ButtonVariant } from '../../common/components/core/button/button.component';
import { UserService } from '../../common/services/user.service';
import { filter, map, Observable, of } from 'rxjs';
import { UserFacility } from '../../common/interfaces/user.interface';
import { UserClient } from '../../common/services/user.client';
import { DropdownItem } from '../../common/interfaces/dropdown-item.interface';
import { ClockInComponent } from '../header/clock-in/clock-in.component';
import { ActivatedRoute, Event, NavigationEnd, Router } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { CommonModule, Location } from '@angular/common';

@UntilDestroy()
@Component({
  selector: 'app-page-header',
  templateUrl: './page-header.component.html',
  styleUrls: ['./page-header.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    ButtonComponent,
    ClockInComponent,
  ]
})
export class PageHeaderComponent implements OnInit {
  @Input() title: string = '';
  @Input() backAction: (() => void) | null = null;
  @Output() epocPageBackButtonTrigger= new EventEmitter<boolean>();

  buttonVariant = ButtonVariant;
  facilities$: Observable<DropdownItem[]> = of([]);
  facilitiesForUser$: Observable<UserFacility[]> = of([]);
  isInAdminRoute: boolean = false;
  user: any = null;
  userDisplayName: string = '';
  ishome: boolean = false;

  constructor(
    private router: Router,
    private userClient: UserClient,
    private userService: UserService,
    private location: Location,
    private activatedRoute: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.user = this.userService.getCurrentUser();
    this.userDisplayName = this.buildUserDisplayName(this.user);
    // TODO: The header component is also doing this, ideally we only do it once
    this.facilitiesForUser$ = this.user?.id
      ? this.userClient
        .getUserFacilities(this.user.id)
        .pipe(map((listResponse: UserFacility[]) => listResponse))
      : of([]);
    this.facilities$ = this.facilitiesForUser$.pipe(
      map((facilities: UserFacility[]) =>
        facilities?.map(
          (userFacility: UserFacility) =>
            ({
              id: userFacility.facilityid,
              name: userFacility.facilityname,
            } as DropdownItem)
        )
      )
    );
    this.ishome = this.router.url.startsWith('/home');
    this.trackRouteChanges();
  }

  goBack(): void {
    if (this.backAction) {
      this.backAction();
      return;
    }
    // If the user is coming from the documentation
    if (this.activatedRoute.snapshot?.routeConfig?.component?.name === "EpocPageComponent") {
      this.epocPageBackButtonTrigger.emit(true);
    }
    else{
        this.location.back();
    }
  }

  /**
   * This method exists because the interface and the return value cached in local storage do not match.
   * This will leverage the expected properties, and fall back to those used by the local test user
   */
  private buildUserDisplayName(user: any): string {
    if (user?.firstname && user?.lastname) {
      return `${user.firstname} ${user.lastname}`;
    }
    return user?.fullname;
  }

  private trackRouteChanges(): void {
    const nonAdminRoutes = ["patient", "time-card", "agenda" , "corporation" , "user" , "reports" , "home"];

    this.isInAdminRoute = !nonAdminRoutes.some(
      (route) => this.router.url.indexOf(route) > -1
    );

    this.router.events
      .pipe(
        filter((event: Event) => event instanceof NavigationEnd),
        map((event: Event) => event as NavigationEnd),
        untilDestroyed(this)
      )
      .subscribe((navigationEnd: NavigationEnd) => {
        this.isInAdminRoute = !nonAdminRoutes.some(
          (route) => navigationEnd.url.indexOf(route) > -1
        );
      });
  }
}
